export const cn = (...classes) => classes.filter(Boolean).join(' ');

export const wait = (ms) => new Promise(r => setTimeout(r, ms));

export const PUBLIC_APP_ORIGIN = 'https://mobile-snap-deploy.lovable.app';

export const buildPublicJoinUrl = (code) => {
  const cleanCode = String(code || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
  return `${PUBLIC_APP_ORIGIN}/join/${cleanCode}`;
};

export const haptic = (type = 'light') => {
  if (navigator.vibrate) {
    const patterns = { light: [10], medium: [20], heavy: [40], success: [10, 50, 10] };
    navigator.vibrate(patterns[type] || [10]);
  }
};
